module.exports = __webpack_public_path__ + "img/1.e97c188d.png";